export const MARKETING_TAGS = 'marketingTags';
export const SESSION_STORAGE_STARTUP_CONFIG = 'startupConfig';
export const GET_CAPITAL_PRIVACY_POLICY_URL = 'https://www.shift.com.au/privacy-policy/';
export const USER_JOURNEY_ACCOUNT_TYPE = {
  BUSINESS_LOANS_ORGANIC: 'Business Loans Organic',
  BUSINESS_LOANS_PAID: 'Business Loans Paid',
  BROKER: 'Broker',
  BROKER_REFERRED_CLIENTS: 'Broker Referred Clients',
  MERCHANT: 'Merchant',
  MERCHANT_REFERRED_CUSTOMER_EF: 'Merchant Referred Customer EF',
  MERCHANT_REFERRED_CUSTOMER_ST: 'Merchant Referred Customer ST',
  CUSTOMER_TRADE_ACCOUNT: 'Customer Trade Account',
  UNCLASSIFIED: 'Unclassified',
};
export const GTM_EVENT_TYPE_USER_JOURNEY = {
  REGO_START: 'Rego Start',
  REGO_BUSINESS_SELECTED: 'Rego Business Selected',
  REGO_MOBILE_ADDED: 'Rego Mobile Added',
  REGO_MOBILE_VERIFIED: 'Rego Mobile Verified',
  REGO_PERSONAL_DETAILS: 'Rego Personal Details',
  REGO_REGISTRATION_SUCCESS: 'Registration Success',
  ACTIVATE_CLIENT: 'Activate Client',
  REGO_ID_UPLOAD_SUCCESS: 'ID upload Success',
  REGO_PERSONAL_DETAILS_FAILED: 'Registration Failed',
  REGO_ID_UPLOAD_FAILED: 'ID upload Failed',
};
export const GTM_USER_JOURNEY_FIELD_NAME = {
  MOBILE_CODE_VALIDATION: 'Mobile Code validation',
  IDENTITY_VERIFICATION_ERROR: 'We could not verify your identity',
};
export const GTM_USER_JOURNEY_ERROR_TYPE = {
  SOMETHING_WENT_WRONG_DURING_REGISTRATION: 'Something went wrong during the registration',
  INCORRECT_CODE_ENTERED: 'The code entered is incorrect. Please check and try again',
  IDENTITY_VERIFICATION_FAILED: 'We could not verify your identity',
};
export const ATTACHMENT_SUPPORTED_FORMATS = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'application/pdf',
];
export const ATTACHMENT_MAX_FILE_NAME_LENGTH = 80;
export const MAX_FILES_ID_VERIFY = 10;
export const MAX_FILE_SIZE_IN_MB_ID_VERIFY = 50;
export const STANDARD_DATE_FORMAT = 'd MMMM yyyy';

export const ID_TYPES = {
  DRIVERSLICENCE: {
    documentTypeId: 18,
    value: 'driversLicence',
    text: 'Driver licence',
    uploadFileText: 'Please upload both the front and back of your driver licence.',
  },
  PASSPORT: {
    documentTypeId: 20,
    value: 'passport',
    text: 'Passport',
    uploadFileText: 'If verifying by passport, upload one image showing an open document.',
  },
  MEDICARE: {
    documentTypeId: 19,
    value: 'medicare',
    text: 'Medicare',
    uploadFileText: 'Medicare card is optional but can assist in helping us verify you.',
  },
};

export const DOCUMENT_STATUSES = {
  Pending: 'Pending',
  Uploaded: 'Uploaded',
  Approved: 'Approved',
};

export const PEP_STATUS = {
  SuspectedPEP: 'SuspectedPEP',
};

export const ANALYTICS_EVENT_DATA_TYPE = {
  DigitalKYCFailed: 'DigitalKYCFailed',
};

export const ALLOWED_PASSPORT_NUMBER_VALIDATION_MESSAGE = 'Please enter a valid passport number';

export const SUPPRESS_ANALYTICS_EVENT = 'suppress-analytics-event';

export const STATES = {
  ACT: 'ACT',
  NSW: 'NSW',
  NT: 'NT',
  QLD: 'QLD',
  SA: 'SA',
  TAS: 'TAS',
  VIC: 'VIC',
  WA: 'WA',
};

export const NETWORK_CONNECTION_ERROR_MESSAGE =
  'Network connection error - please check your connection and try again.';

export const NETWORK_ERROR = 'Network Error';

export const SESSION_URL = 'Session_Url';

export const QUERY_PARAMS = {
  INVITER_ROLE: 'inviterRole',
  RECIPIENT_GC_CONTACT_ID: 'recipient_gc_contact_id',
  INVITATION_CODE: 'invitationCode',
};

export const ACCOUNT_TYPE = {
  BROKER: 'broker',
};
